/* eslint-disable @typescript-eslint/no-invalid-void-type */
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { prepareHeaders, getApiBaseUrl } from 'utility/Api'
import { Diploma, Location } from 'types'

const baseUrl = getApiBaseUrl()
const apiPath = 'commencement-v1'

// Define a service using a base URL and expected endpoints
export const DiplomaApi = createApi({
  reducerPath: 'DiplomaApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `https://${baseUrl}/${apiPath}`,
    prepareHeaders: async headers => await prepareHeaders(headers)
  }),
  tagTypes: ['diplomas'],
  endpoints: builder => ({
    getDiplomas: builder.query<Diploma[], string>({
      query: q => `diplomas?mitId=${q}`,
      providesTags: [{ type: 'diplomas', id: 'DIPLOMAS' }],
      transformResponse: (response: Diploma[]) => {
        return response.map(row => ({ id: row.id, name: row.name, level: row.level, status: row.status, room: row.room }))
      }
    }),
    getLocations: builder.query<Location[], void>({
      query: () => 'locations',
      transformResponse: (response: Location[]) => {
        return response.map(row => ({ name: row.name, latitude: row.latitude, longitude: row.longitude }))
      }
    })
  })
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetDiplomasQuery, useGetLocationsQuery } = DiplomaApi
